import * as Sentry from "@sentry/react";

// 직접적인 Sentry 테스트 함수들
export const testSentryConnection = () => {
  console.log('🧪 Sentry 연결 테스트 시작...');
  
  // Network 요청 모니터링
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0] as string;
    if (url.includes('sentry.io') || url.includes('ingest')) {
      console.log('📡 Sentry로 전송되는 Network 요청:', url);
      
      return originalFetch.apply(this, args)
        .then(response => {
          console.log('📡 Sentry 응답 상태:', response.status, response.statusText);
          if (response.ok) {
            console.log('✅ Sentry 전송 성공!');
          } else {
            console.error('❌ Sentry 전송 실패:', response.status);
          }
          return response;
        })
        .catch(error => {
          console.error('❌ Sentry 네트워크 에러:', error);
          throw error;
        });
    }
    return originalFetch.apply(this, args);
  };
  
  // 1. 단순 메시지 전송
  Sentry.captureMessage('테스트 메시지 - Sentry 연결 확인', 'info');
  console.log('📤 메시지 전송 완료');
  
  // 2. 예외 전송
  const testError = new Error('테스트 에러 - Sentry 연결 확인');
  Sentry.captureException(testError);
  console.log('📤 예외 전송 완료');
  
  // 3. 브레드크럼 추가 후 에러
  Sentry.addBreadcrumb({
    message: 'Sentry 테스트 브레드크럼',
    category: 'test',
    level: 'info',
    data: {
      test_type: 'connection_test',
      timestamp: new Date().toISOString()
    }
  });
  
  Sentry.captureException(new Error('브레드크럼과 함께 전송되는 테스트 에러'));
  console.log('📤 브레드크럼과 함께 에러 전송 완료');
  
  // 4. 사용자 컨텍스트 설정 후 에러
  Sentry.setUser({
    id: 'test-user-123',
    username: '테스트사용자',
    email: 'test@example.com'
  });
  
  Sentry.captureException(new Error('사용자 컨텍스트와 함께 전송되는 테스트 에러'));
  console.log('📤 사용자 컨텍스트와 함께 에러 전송 완료');
  
  console.log('✅ 모든 Sentry 테스트 전송 완료!');
  console.log('📊 Sentry 대시보드를 확인해보세요: https://sentry.io/');
  
  // 3초 후 fetch 복원
  setTimeout(() => {
    window.fetch = originalFetch;
    console.log('🔄 원래 fetch 함수로 복원됨');
  }, 3000);
};

// 즉시 실행 가능한 전역 함수로 등록
if (typeof window !== 'undefined') {
  (window as any).testSentry = testSentryConnection;
  console.log('🌐 window.testSentry() 함수가 등록되었습니다. 콘솔에서 직접 실행할 수 있습니다.');
} 